export enum LeavingVesselHandling {
    ENTIRELY = 'ENTIRELY',
    PRO_RATA = 'PRO_RATA',
}
